import { Component, EventEmitter, OnInit, Output, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { PraticaSelect } from 'src/app/common/models/pratica/intestazione-pratica/pratica-select';
import { PraticaBase } from 'src/app/common/models/pratica/pratica-base';
import { FrontEndMapping } from 'src/app/core/configuration/front-end-mapping';
import { OperationsService } from 'src/app/core/services/operations.service';
import { SearchPraticheComponent } from '../../../input-component/searchPratiche/search-pratiche.component';
import { RicercatoreFulltextPratiche } from '../../../pratica/creazione/ricercatore-fulltext-pratiche.component';
import { FascicoloSelectModal } from '../../aggiungiFascicolo/fascicolo-select-modal.component';

declare var closeModal: any;
declare var openModal: any;
declare var getPraticaMapSync: any;

@Component({
  selector: 'div [ricerca-precedenti]',
  templateUrl: './ricerca-precedenti.component.html',
  styleUrls: ['./ricerca-precedenti.component.css'],
  host: { '[class.modal]': '\'true\'', '[class.fade]': '\'true\'', '[attr.role]': '\'dialog\'' }
})
export class RicercaPrecedentiComponent implements OnInit {
  pratica: PraticaBase;
  praticheCorrelate: PraticaSelect[];
  pratichePrecedenti: PraticaSelect[] = [];
  praticaCopyInfo: PraticaSelect = null;
  resetPrecedenti: boolean;
  idFormPratica: string;
  classificazioniCopyPratica
  @ViewChild('fascicoloSelectModal') fascicoloSelectModal: FascicoloSelectModal;
  @ViewChild('searchPratiche') searchPraticheInput: SearchPraticheComponent;
  afterViewInit: boolean = false;
  onPagePrecedenti: boolean = false;
  @Output() onReturn: EventEmitter<boolean> = new EventEmitter<boolean>();

  constructor(protected operationService: OperationsService, private router: Router, private frontEndMapping: FrontEndMapping) {
  }

  ngOnInit() {
    if (this.router.url.indexOf('pratiche_precedenti') !== -1) {
      this.onPagePrecedenti = true;
    } else {
      this.onPagePrecedenti = false;
    }
  }
  
  inizializza(pratica: PraticaBase) {
    this.pratica = pratica;
  }

  retrieveEventSave() {
    this.pratica = undefined;
    if (this.onPagePrecedenti) {
      this.onReturn.emit(true)
    }
    closeModal('modalRicercaPrecedenti');
  }

  onClose(){
    this.pratica = undefined;
    this.pratichePrecedenti = [];
    this.resetPrecedenti = true;
    this.searchPraticheInput?.onResetSearchText();
    closeModal('modalRicercaPrecedenti');
  }
  

}
